import React, { useState, useEffect } from 'react';
import Routes from '../../routes';
import {
    PrimaryButton,
    Table,
    Column,
    LoadingBar,
    BreadCrumbs,
} from '../Common';

const ServiceProviders = ({
    history: {
        push = () => { }
    } = {}
}) => {
    const [filters, setFilters] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        const response = await fetch(Routes.Asset.TableFilters());
        const data = await response.json();
        setFilters(data);
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {
        return <LoadingBar />;
    }

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Account', to: `/Account` },
                    { text: 'Service Providers' }
                ]}
            />
            <div className="row flex f-row f-jb">
                <h1>Service Providers</h1>                      
                <div>
                    <PrimaryButton
                        buttonText='Add New Service Provider'
                        onClick={() => {}}
                    />
                   {/*  <Button tag={Link} to="/AddServiceProvider">ADD NEW SERVICE PROVIDER<img src="/images/ic_add.svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        alt="Add New Service Provider"
                        className="svg-white" />
                    </Button> */}
                </div>

            </div>

            <div className="top-banner flex">
                <Table url={Routes.Asset.AssetTable()} filterOptions={filters}>
                    <Column title="ID" property="id" link="/Inventory/" linkId="id" filter="text" />
                    <Column title="SERVICE PROVIDER NAME" property="ServiceProviderName" filter="dropdown" />
                    <Column title="GRANT TYPE" property="grantType" noSort="true" />
                    <Column title="CAN MANAGE LOCATIONS" property="canManageLocations" filter="text" />
                    <Column title="REQUIRE ADMIN APPROVAL" property="requuireAdminApproval" filter="text" />
                    <Column title="" link="/Inventory/" linkId="id" icon="/images/ic_search.svg" noSort="true" />
                    <Column title="" link="/Inventory/History/" linkId="id" icon="/images/ic_inventory_add.svg" noSort="true" hover="Add Asset" />
                </Table>
            </div>
        </>
    );
};

export default ServiceProviders;
